export const SET_ALERTS = 'SET_ALERTS';
